import { createContext, ReactNode, useContext, useMemo } from 'react';

export type FeatureFlagContext = Readonly<unknown>;

const Context = createContext<FeatureFlagContext | undefined>(undefined);

export type FeatureFlagProviderProps = Readonly<{ children?: ReactNode }>;

export function FeatureFlagProvider({ children }: FeatureFlagProviderProps) {
    const value = useMemo<FeatureFlagContext>(() => ({}), []);

    return <Context.Provider value={value}>{children}</Context.Provider>;
}

export function useFeatureFlags(): FeatureFlagContext {
    const ctx = useContext(Context);
    if (!ctx) {
        throw new Error('Missing <FeatureFlagProvider>');
    }
    return ctx;
}
